export function getDaysInMonth () {
  let days = [...Array(32).keys()]
  days.shift()
  days = days.map(d => {
    return { number: ('0' + d.toString()).slice(-2), value: d.toString() }
  })

  return days
}

export function getMonthsInYear () {
  const months = [
    { number: '01', value: 'common_JanMonth_placeholder' },
    { number: '02', value: 'common_febMonth_placeholder' },
    { number: '03', value: 'common_MarchMonth_placeholder' },
    { number: '04', value: 'common_aprilMonth_placeholder' },
    { number: '05', value: 'common_MayMonth_placeholder' },
    { number: '06', value: 'common_junMonth_placeholder' },
    { number: '07', value: 'common_julyMonth_placeholder' },
    { number: '08', value: 'common_augMonth_placeholder' },
    { number: '09', value: 'common_sepMonth_text' },
    { number: '10', value: 'common_OctMonth_placeholder' },
    { number: '11', value: 'common_NovMonth_placeholder' },
    { number: '12', value: 'common_decMonth_placeholder' }
  ]

  return months
}

export function getYears (lastYear = 1900) {
  let year = (new Date().getFullYear() - 15)
  const years = []

  while (year >= lastYear) {
    years.push(year--)
  }

  return years
}
